export default {
    setSelectedPreOrderUnit(state, unit) {
        state.selectedPreOrderUnit = unit;
    },
};
